import React, {useEffect, useState} from "react";
import useAxios from "axios-hooks";
import {Link, useLocation} from "react-router-dom";
import Button from "@mui/material/Button";
import {
    AutoGraphTwoTone,
    AccountCircleTwoTone,
    PriceCheckTwoTone,
    VerifiedTwoTone,
    StorageTwoTone, LocalOfferTwoTone, Logout, LogoutTwoTone, ForumTwoTone, HelpTwoTone, LoginTwoTone
} from "@mui/icons-material";
import GrafanaIframe from "./GrafanaIframe";
import GrafanaIframeNoAuth from "./GrafanaIframeNoAuth";
import Cookies from "js-cookie";
import {IconButton} from "@mui/material";
import axios from "axios";

export default function Stage() {
    const [authToken, setAuthToken] = useState("");
    const [data, setData] = useState("");
    const [numSessions, setNumSessions] = useState(0);
    const [subscription, setSubscription] = useState("steel");
    const [showSmallToolbar, setShowSmallToolbar] = useState(false);
    const [iframeSource, setIframeSource] = useState("");


    useEffect(() => {
        const checkViewWidth = () => {
            const viewWidth = document.getElementById('appViewHolder').offsetWidth;
            setShowSmallToolbar(viewWidth < 1024);
        };
        const auth = Cookies.get('auth');
        const email = Cookies.get('email');
        if (auth && email) {
            authUser(auth).then(r => {
                setAuthToken(auth);
                fetchUserDetails(email, auth).then();
            } );

        } else {
            handleOffers(data, numSessions);
        }

        window.addEventListener('resize', checkViewWidth);
        checkViewWidth(); // Initial check
        return () => window.removeEventListener('resize', checkViewWidth);
    },[]);

    const authUser = async (authToken) => {
        const encodedAuthToken = encodeURIComponent(authToken);
        try {
            const response = await fetch('../api/user/auth?token=' + encodedAuthToken, {
                method: 'GET'
            });

            if (response.ok) {
                await response.json();
            } else {
                handleOffers(data, numSessions);
            }
        } catch (error) {
            window.location.href = './login';
        }
    };

    const fetchUserDetails = async (email, authToken) => {
        try {
            const response = await fetch("../api/user/getUser?email=" + email, {
                method: 'GET'
            });
            if (response.ok) {
                const data = await response.json();
                setData(data);
                const numSessions = await fetchUserGrafanaSessions(authToken);
                setNumSessions(numSessions);
                handleOffers(data, numSessions);
            } else {
                window.location.href = './login';
            }
        } catch (error) {
            window.location.href = './login';
        }
    };

    const fetchUserGrafanaSessions = async (token) => {
        const formData = new URLSearchParams();
        formData.append('token', token);
        try {
            const response = await axios.post('../api/grafana/getUserSessions', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if(response.status >= 200 && response.status < 300) {
                const sessions = response.data;
                return sessions;
            }
            return 0;
        } catch (error) {
            console.error("Error in fetchUserGrafanaSessions:", error);
            return 0;
        }
    };

    const handleLogout = () => {
        Cookies.remove("auth");
        Cookies.remove("email");
        Cookies.remove("grafana_session");
        window.location.href = './login';
    }


    const handleOffers = (data, numSessions) => {
        if(data) {
            //console.log("handleOffers() data.subscription " + data.subscription + " data.enabled " + data.enabled + " numSessions " + numSessions);
            const source = data.subscription === "aluminium" ?
                "https://wovenvideo.ca/analytics/d/c03f1c6d-6054-4772-b402-8b3ef8390055/offers?orgId=1" :
                data.subscription === "titanium" ?
                    "https://wovenvideo.ca/analytics/d/c0dfd4fd-2483-4fe6-af87-3a9ceb36e0f1/offers?orgId=1" :
                    "https://wovenvideo.ca/analytics/d/prod-community-live-offers/offers?orgId=1";
            if (!data.enabled) {
                setIframeSource("https://wovenvideo.ca/analytics/d/prod-community-live-offers/offers?orgId=1");
            } else if (data.enabled && numSessions === 0) {
                setIframeSource("https://wovenvideo.ca/analytics/login");
            } else {
                setIframeSource(source);
            }
        } else {
            setIframeSource("https://wovenvideo.ca/analytics/d/prod-community-live-offers/offers?orgId=1");
        }
    };

    const handleMachines = (subscription) => {
        const source = subscription === "aluminium" ?
            "https://wovenvideo.ca/analytics/d/fb17239f-23f9-4e59-adfe-5e19e51c82ff/machines?orgId=1" :
            subscription === "titanium" ?
            "https://wovenvideo.ca/analytics/d/ca28cdd1-421c-4721-b8b0-3e8ae30f335a/machines?orgId=1" :
                "https://wovenvideo.ca/analytics/d/prod-community-live-machines/machines?orgId=1";
        if(!data.enabled) {
            setIframeSource("https://wovenvideo.ca/analytics/d/prod-community-live-machines/machines?orgId=1");
        } else {
            setIframeSource(source);
        }
    };

    const handlePerformance = (subscription) => {
        const source = subscription === "aluminium" ?
            "https://wovenvideo.ca/analytics/d/prod-com-machine-review/performance?orgId=1" :
            subscription === "titanium" ?
                "https://wovenvideo.ca/analytics/d/f0537cd6-7633-4c0c-aee8-508ad7514b78/performance?orgId=1" :
                "https://wovenvideo.ca/analytics/d/prod-com-live-mac-cfg-offers/performance?orgId=1";
        if(!data.enabled) {
            setIframeSource("https://wovenvideo.ca/analytics/d/prod-com-live-mac-cfg-offers/performance?orgId=1");
        } else {
            setIframeSource(source);
        }
    };

    const handleVerified = (subscription) => {
        const source = subscription === "aluminium" ?
            "https://wovenvideo.ca/analytics/d/f99bfa48-2e12-4ad8-9b61-6b0519f5b24a/verified?orgId=1" :
            subscription === "titanium" ?
            "https://wovenvideo.ca/analytics/d/d37a5032-4735-4214-abde-b040e77a1576/verified?orgId=1" :
                "https://wovenvideo.ca/register";

        if(!authToken || !data.enabled) {
            window.location.href = "https://wovenvideo.ca/register";
        } else {
            setIframeSource(source);
        }
    };

    const handleEstimate = (subscription) => {
        const source = subscription === "aluminium" ?
            "https://wovenvideo.ca/analytics/d/b65c4ece-ffd3-404d-86c2-225554ab0f9b/estimate?orgId=1" :
            subscription === "titanium" ?
            "https://wovenvideo.ca/analytics/d/d7411b23-ef56-4cbb-98bc-7003e0dbb12b/estimate?orgId=1" :
                "https://wovenvideo.ca/register";
        if(!authToken || !data.enabled) {
            window.location.href = "https://wovenvideo.ca/register";
        } else {
            setIframeSource(source);
        }
    };



    const handleCommunity = (subscription) => {
        window.location.href = 'https://discord.gg/63xuhRTWrw';
    };

    const handleHelp = (subscription) => {
        window.location.href = 'https://wovenvideo.ca/index_analytics.html#overview';
    };



    return (
        <div id="appViewHolder">
            {showSmallToolbar ? (
                <div id="toolbarSmall" className="Toolbar">
                    <span className="ButtonHolder">
                        <IconButton size="small"
                                    sx={{ color: theme => theme.palette.primary.light }}
                                    onClick={() => handleOffers(data, numSessions)}>
                            <LocalOfferTwoTone/>
                        </IconButton>
                    </span>
                    <span className="ButtonHolder">
                        <IconButton size="small"
                                    sx={{ color: theme => theme.palette.primary.light }}
                                    onClick={() => handleMachines(data.subscription)}>
                            <StorageTwoTone/>
                        </IconButton>
                    </span>
                    <span className="ButtonHolder">
                        <IconButton size="small" sx={{ color: theme => theme.palette.primary.light }}
                                    onClick={() => handlePerformance(data.subscription)}>
                            <AutoGraphTwoTone/>
                        </IconButton>
                    </span>
                    <span className="ButtonHolder">
                        <IconButton size="small"
                                    sx={{ color: theme => theme.palette.primary.light }}
                                    onClick={() => handleVerified(data.subscription)}>
                            <VerifiedTwoTone/>
                        </IconButton>
                    </span>
                    <span className="ButtonHolder">
                        <IconButton size="small"
                                    sx={{ color: theme => theme.palette.primary.light }}
                                    onClick={() => handleEstimate(data.subscription)}>
                            <PriceCheckTwoTone/>
                        </IconButton>
                    </span>



                    <span className="ButtonHolder">
                        <IconButton size="small" sx={{ color: theme => theme.palette.primary.light }}
                                    onClick={() => handleCommunity(data.subscription)}>
                            <ForumTwoTone/>
                        </IconButton>
                    </span>
                    <span className="ButtonHolder">
                        <IconButton color="primary" size="small" sx={{ color: theme => theme.palette.primary.light }}
                                    onClick={() => handleHelp(data.subscription)}>
                            <HelpTwoTone/>
                        </IconButton>
                    </span>

                    <span className="ButtonHolder">
                    {authToken ? (
                        <IconButton  color="secondary" size="small" onClick={handleLogout}>
                            <LogoutTwoTone/>
                        </IconButton>
                    ) :(
                        <Link to="/profile">
                            <IconButton  color="success" size="small">
                                <LoginTwoTone/>
                            </IconButton>
                        </Link>
                    ) }
                        </span>

                    {authToken && (
                    <span className="ButtonHolder">
                        <Link to="/profile">
                            <IconButton color="success" size="small">
                                <AccountCircleTwoTone/>
                            </IconButton>
                        </Link>
                    </span>
                    )}
                </div>
            ) : (
                <div id="toolbarFull" className="Toolbar">
                    <span className="ButtonHolder">
                        <Button size="small"
                                startIcon={<LocalOfferTwoTone/>}
                                sx={{ color: theme => theme.palette.primary.light }}
                                onClick={() => handleOffers(data, numSessions)}>
                            Offers
                        </Button>
                    </span>
                    <span className="ButtonHolder">
                        <Button size="small" startIcon={<StorageTwoTone/>}
                                className="Button"
                                sx={{ color: theme => theme.palette.primary.light }}
                                onClick={() => handleMachines(data.subscription)}>
                            Machines
                        </Button>
                    </span>

                    <span className="ButtonHolder">
                        <Button variant="text" size="small"
                                startIcon={<AutoGraphTwoTone/>}
                                className="ButtonHolder"
                                sx={{ color: theme => theme.palette.primary.light }}
                                onClick={() => handlePerformance(data.subscription)}>
                            Performance
                        </Button>
                    </span>
                    <span className="ButtonHolder">
                        <Button size="small"
                                startIcon={<VerifiedTwoTone/>}
                                className="Button"
                                sx={{ color: theme => theme.palette.primary.light }}
                                onClick={() => handleVerified(data.subscription)}>
                            Verified
                        </Button>
                    </span>
                    <span className="ButtonHolder">
                        <Button size="small"
                                startIcon={<PriceCheckTwoTone/>}
                                className="ButtonHolder"
                                sx={{ color: theme => theme.palette.primary.light }}
                                onClick={() => handleEstimate(data.subscription)}>
                            Estimate
                        </Button>
                    </span>



                    <span className="ButtonHolder">
                        <Button size="small"
                                startIcon={<ForumTwoTone/>}
                                sx={{ color: theme => theme.palette.primary.light }}
                                onClick={() => handleCommunity(data.subscription)}>
                        COMMUNITY
                        </Button>
                    </span>
                    <span className="ButtonHolder">
                        <IconButton color="primary" size="small" sx={{ color: theme => theme.palette.primary.light }}
                                    onClick={() => handleHelp(data.subscription)}>
                            <HelpTwoTone/>
                        </IconButton>
                    </span>
                    <span className="ButtonHolder">
                        {authToken ? (
                            <IconButton  color="secondary" size="small" onClick={handleLogout}>
                                <LogoutTwoTone/>
                            </IconButton>
                        ):(
                            <Link to="/login">
                                <Button variant="outlined" color="success" size="medium"
                                        startIcon={<LoginTwoTone/>}
                                        className="ButtonHolder">
                                    LOGIN / SUBSCRIBE
                                </Button>
                            </Link>
                        )}

                    </span>
                    {authToken && (
                        <span className="ButtonHolder">
                            <Link to="/profile">
                                <Button variant="outlined" color="success" size="medium"
                                        startIcon={<AccountCircleTwoTone/>}
                                        className="ButtonHolder">
                                    {data.screenName}
                                </Button>
                            </Link>
                        </span>
                    )}
                </div>
            )}

            <div>
                <iframe src={iframeSource} title="Woven Dashboards" className="AppIFrame"/>
            </div>
        </div>
    );
}